import { Device, until } from '@helpers/media';
import useMedia from '@hooks/useMedia';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import { ContentType } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import * as React from 'react';
import S from './ProductHero.styles';
const ProductHero = (props) => {
    const rowMax = useMedia([
        until(Device.TabletSmall),
        until(Device.Tablet),
        until(Device.TabletLarge),
        until(Device.DesktopSmall),
    ], [2, 3, 4, 5], 6);
    if (props.featureBoxes.length === 0) {
        return null;
    }
    return (React.createElement(S.Container, { "data-theme": props.theme ?? ContentType.Default, translations: props.translations },
        React.createElement(S.Wrapper, null,
            React.createElement(S.TopArea, null,
                props.tag && React.createElement(S.Tag, null, props.tag),
                React.createElement(S.Title, null, props.title),
                props.introduction && React.createElement(S.Introduction, null, props.introduction)),
            props.featureBoxes && props.featureBoxes.length > 0 && (React.createElement(S.Features, { rowMax: rowMax, "data-single-col": props.featureBoxes.length <= 3 }, props.featureBoxes.map((feature, index) => (React.createElement(S.Feature, { key: `feature-${index}` },
                React.createElement(S.FeatureTitle, null, feature.title),
                feature.tooltip && (React.createElement(S.Info, null,
                    React.createElement(S.InfoButton, { "aria-label": props.translations?.['global.tooltip.label'], "aria-describedby": `feature-${index}-label`, onClick: (e) => e.preventDefault() }, "?"),
                    React.createElement(S.Tooltip, { id: `feature-${index}-label`, role: "tooltip" }, feature.tooltip))),
                React.createElement(S.FeatureContent, null, feature.content)))))),
            React.createElement(S.BottomArea, null,
                props.summaryBullets && props.summaryBullets.length > 0 && (React.createElement(S.SummaryBullets, null, props.summaryBullets.map((bullet, index) => (React.createElement("li", { key: `bullet-${index}` }, bullet))))),
                props.cta && (React.createElement(LinkButton, { href: props.cta.url, buttonType: "tertiary", "aria-label": props.cta.text }, props.cta.text))))));
};
export default ProductHero;
